module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "lines"
  }, [_c('img', {
    staticClass: "img23",
    attrs: {
      "alt": "",
      "src": "Images/line_top.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp4"
  }, [_vm._v("THIRD EDITION")]), _vm._v(" "), _c('div', {
    staticClass: "lines"
  }, [_c('img', {
    staticClass: "img23",
    attrs: {
      "alt": "",
      "src": "Images/line_bottom.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp3",
    staticStyle: {
      "font-size": "1.1em"
    }
  }, [_c('i', [_vm._v("An Introduction to")])]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "2.2em",
      "margin-top": ".1em"
    },
    attrs: {
      "title": "Title Page"
    }
  }, [_vm._v("BIBLICAL"), _c('br'), _vm._v("\n  ETHICS")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_c('i', [_vm._v("WALKING IN THE WAY OF WISDOM")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("Robertson McQuilkin"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("and")]), _vm._v(" Paul Copan")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('img', {
    attrs: {
      "alt": "IVP Academic Imprint",
      "src": "Images/IVP_Academic_Quarter.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/books",
      "target": "_blank"
    }
  }, [_vm._v("www.IVPress.com/academic")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ceaacd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 57
// module chunks = 0